const EInvoiceCockpit = () => import('@/modules/EInvoice/EInvoiceCockpit')
const EInvoiceDetails = () => import('@/modules/EInvoice/EInvoiceDetails')

const eInvoiceDetailsProps = route => {
	const eInvoiceId = Number.parseInt(route.params.eInvoiceId, 16)
	const vendorId = Number.parseInt(route.params.vendorId, 16)
	return { value: eInvoiceId, eInvoiceVendorId: vendorId }
}

const eInvoiceChildren = [
	{
		component: EInvoiceDetails,
		path: 'invoice/:vendorId/:eInvoiceId',
		props: eInvoiceDetailsProps
	}
]

export default ['invoice-cockpit', 'invoice-cockpit-vendor'].map(name => ({
	component: EInvoiceCockpit,
	name,
	path: 'invoices/:context?',
	children: eInvoiceChildren.map(child => ({
		...child,
		name: `${name}-details`
	}))
}))
